var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessuser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5229 21.99H4.48785C2.98485 21.99 1.82485 20.856 2.02185 19.366L2.13585 18.497C2.34285 17.297 3.44085 16.542 4.63285 16.283L11.9279 15H12.0719L19.3669 16.283C20.5789 16.563 21.6569 17.276 21.8639 18.497L21.9779 19.377C22.1749 20.867 21.0149 22 19.5119 22L19.5229 21.99ZM16.9999 7C16.9999 8.32608 16.4731 9.59785 15.5354 10.5355C14.5977 11.4732 13.3259 12 11.9999 12C10.6738 12 9.402 11.4732 8.46432 10.5355C7.52664 9.59785 6.99985 8.32608 6.99985 7C6.99985 5.67392 7.52664 4.40215 8.46432 3.46447C9.402 2.52678 10.6738 2 11.9999 2C13.3259 2 14.5977 2.52678 15.5354 3.46447C16.4731 4.40215 16.9999 5.67392 16.9999 7Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessuser);
export default __webpack_public_path__ + "static/media/business user.b914f6e581216521e194f536b4a8f6f4.svg";
export { ForwardRef as ReactComponent };